import { combineReducers } from 'redux';

import paypal from './paypal';
import channelsDealInfo from './channels-deal-info';
import videosDealInfo from './videos-deal-info';


export default combineReducers({
  paypal,
  videosDealInfo,
  channelsDealInfo,
});



// WEBPACK FOOTER //
// ./src/shared/redux/client/reducers/payments/index.js